<template>
  <div
    class="w-fit rounded-full bg-primary px-3 py-1.5 text-sm text-text-main"
    :class="[computedClasses, { absolute: positionX || positionY }]"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

type PropType = {
  positionY?: 'top' | 'bottom' | 'center' | ''
  positionX?: 'left' | 'right' | 'center' | ''
}

const props = withDefaults(defineProps<PropType>(), {
  severity: 'primary',
  size: 'small',
  positionX: '',
  positionY: ''
})

const positionXClassesMap: Record<NonNullable<PropType['positionX']>, string> = {
  left: 'left-0 right-auto',
  center: 'inset-x-center',
  right: 'right-0 left-auto',
  '': ''
}
const positionYClassesMap: Record<NonNullable<PropType['positionY']>, string> = {
  top: 'top-0 bottom-auto',
  center: 'inset-y-center',
  bottom: 'top-auto bottom-0',
  '': ''
}

const computedClasses = computed(() =>
  [positionXClassesMap[props.positionX], positionYClassesMap[props.positionY]].join(' ')
)
</script>
